<template>
  <!-- Please do not remove this layout. It is not directly used anywhere, but resolves a problem where the page 'jumps up' on page load (ORP-2239) -->
  <v-app></v-app>
</template>

<script>
export default {};
</script>
